const _1_MINUTE = 60 * 1000;
export const _1_HOUR = 60 * _1_MINUTE;
const _1_DAY = 24 * _1_HOUR;
export const _3_DAYS = 3 * _1_DAY;
